// extracted by mini-css-extract-plugin
module.exports = {"page":"style_page__hjaa9","content":"style_content__FSENI"};